import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import JPGToPDFLandingPageFullWidthUploadPanel from './JPGToPDFLandingPageFullWidthUploadPanel';

const JPGToPDFLandingPageFreeWriteBackgroundLayout = (props) => {
  const jpgToPdfContainerClasses = classNames(
    'jpg-to-pdf-container',
    'large-upload-panel-mock-freewrite-wrapper',
    'large-upload-panel-wrapper',
  );
  return (
    <div className={jpgToPdfContainerClasses}>
      <img
        src="/images/jpg-pdf-toolbar-web.png"
        alt="Mock Free Write Background"
        className="large-upload-panel-mock-freewrite-bg-img img-lg"
      />
      <img
        src="/images/jpg-pdf-toolbar-mobile.png"
        alt="Mock Free Write Background"
        className="large-upload-panel-mock-freewrite-bg-img img-xs"
      />
      <JPGToPDFLandingPageFullWidthUploadPanel
        ctaId={props.ctaId}
        subHeader="And explore our whole selection of editing tools."
      />
    </div>
  );
};

JPGToPDFLandingPageFreeWriteBackgroundLayout.propTypes = {
  ctaId: PropTypes.string.isRequired,
};

export default JPGToPDFLandingPageFreeWriteBackgroundLayout;



// WEBPACK FOOTER //
// ./src-react/JPGToPDFLandingPage/JPGToPDFLandingPageFreeWriteBackgroundLayout.jsx